var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogosWhatsappIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 47,
    viewBox: "0 0 46 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_623_259)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.981648 22.9022C0.98057 26.7973 1.99832 30.6006 3.93355 33.9528L0.79657 45.4065L12.5179 42.3331C15.7599 44.098 19.3923 45.0228 23.0836 45.023H23.0933C35.2788 45.023 45.1981 35.1073 45.2033 22.9197C45.2056 17.0139 42.9078 11.4605 38.7329 7.28236C34.5588 3.10463 29.0073 0.802653 23.0924 0.799957C10.9054 0.799957 0.986859 10.7151 0.981828 22.9022",
    fill: "url(#paint0_linear_623_259)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.192266 22.8951C0.191008 26.9303 1.24523 30.8696 3.24947 34.3419L0 46.2061L12.1417 43.0226C15.4871 44.8466 19.2537 45.8083 23.0864 45.8097H23.0963C35.719 45.8097 45.9946 35.5373 46 22.9134C46.0022 16.7954 43.6217 11.0423 39.2977 6.71456C34.9731 2.38733 29.2231 0.00251563 23.0963 0C10.4715 0 0.197297 10.2709 0.192266 22.8951ZM7.42289 33.7439L6.96954 33.0242C5.06377 29.994 4.05788 26.4922 4.05932 22.8965C4.06345 12.4037 12.6029 3.86688 23.1035 3.86688C28.1887 3.86903 32.9676 5.85134 36.5621 9.44797C40.1564 13.045 42.1342 17.8264 42.1329 22.912C42.1283 33.4048 33.5886 41.9427 23.0963 41.9427H23.0888C19.6724 41.9409 16.3217 41.0234 13.3997 39.2896L12.7043 38.8772L5.49916 40.7662L7.42289 33.7437V33.7439Z",
    fill: "url(#paint1_linear_623_259)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3718 13.3235C16.9431 12.3706 16.4919 12.3513 16.0842 12.3346C15.7503 12.3203 15.3687 12.3213 14.9874 12.3213C14.6057 12.3213 13.9856 12.4649 13.4615 13.0372C12.9368 13.6101 11.4583 14.9944 11.4583 17.8099C11.4583 20.6256 13.5091 23.3466 13.795 23.7288C14.0812 24.1103 17.754 30.073 23.5709 32.3669C28.4052 34.2732 29.389 33.8941 30.4382 33.7985C31.4875 33.7033 33.8242 32.4145 34.3009 31.0782C34.778 29.742 34.778 28.5967 34.6349 28.3574C34.4919 28.1189 34.1103 27.9757 33.538 27.6896C32.9655 27.4034 30.1519 26.0189 29.6274 25.8279C29.1027 25.6371 28.7212 25.5418 28.3396 26.1149C27.9579 26.687 26.862 27.9757 26.528 28.3574C26.1943 28.7399 25.8603 28.7875 25.2881 28.5013C24.7155 28.2142 22.8724 27.6106 20.6858 25.6612C18.9845 24.1442 17.836 22.271 17.5021 21.698C17.1682 21.1258 17.4663 20.8157 17.7533 20.5305C18.0104 20.2741 18.3258 19.8623 18.6122 19.5282C18.8976 19.194 18.9928 18.9556 19.1836 18.5739C19.3746 18.1919 19.279 17.8577 19.1362 17.5714C18.9928 17.2852 17.8807 14.4549 17.3718 13.3235Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_623_259",
    x1: 2221.13,
    y1: 4461.45,
    x2: 2221.13,
    y2: 0.799957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FAF38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_623_259",
    x1: 2300,
    y1: 4620.61,
    x2: 2300,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_623_259"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46.3594,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogosWhatsappIcon);
export default __webpack_public_path__ + "static/media/logos_whatsapp-icon.19669be38bcc009e53c75b77393822dd.svg";
export { ForwardRef as ReactComponent };